import SettingsModal from './SettingsModal';

export default SettingsModal;



// WEBPACK FOOTER //
// ./src/components/SettingsModal/index.js